import { render, staticRenderFns } from "./CourseListView.vue?vue&type=template&id=6375d1b9&scoped=true"
import script from "./CourseListView.vue?vue&type=script&lang=js"
export * from "./CourseListView.vue?vue&type=script&lang=js"
import style0 from "./CourseListView.vue?vue&type=style&index=0&id=6375d1b9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6375d1b9",
  null
  
)

export default component.exports